var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "checkbox-1",
                    name: "checkbox-1",
                    value: 1,
                    "unchecked-value": 0
                  },
                  model: {
                    value: _vm.isNewCustomer,
                    callback: function($$v) {
                      _vm.isNewCustomer = $$v
                    },
                    expression: "isNewCustomer"
                  }
                },
                [_vm._v("\n          Penjualan customer baru\n        ")]
              ),
              _vm._v(" "),
              !_vm.isNewCustomer
                ? _c("fg-input", { attrs: { label: "Customer" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group input-typeahead",
                        class: _vm.customerError !== null ? "has-error" : ""
                      },
                      [
                        _c("typeahead", {
                          ref: "userProfileUuidTypeahead",
                          attrs: {
                            customQueryParamName: "name",
                            labelFields: ["name"],
                            placeholder: "Cari Customer",
                            urlSearch: _vm.apiUrl.customer,
                            "arr-response": "data",
                            model: _vm.model.customer
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", model: _vm.checkCustomer }
                        }),
                        _vm._v(" "),
                        _vm.customerError !== null
                          ? _c("p", {
                              staticClass: "error",
                              domProps: { innerHTML: _vm._s(_vm.customerError) }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("fg-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.modelValidations.name,
                                expression: "modelValidations.name"
                              }
                            ],
                            attrs: {
                              required: false,
                              "for-input": "name",
                              type: "text",
                              name: "name",
                              id: "name",
                              label: "Nama",
                              placeholder: "Masukkan nama",
                              error: _vm.errors.first("name"),
                              "data-vv-as": "Name"
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          }),
                          _vm._v(" "),
                          _c("fg-input", {
                            attrs: {
                              type: "text",
                              name: "address",
                              id: "address",
                              label: "Alamat",
                              placeholder: "Enter address"
                            },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          }),
                          _vm._v(" "),
                          _c("fg-input", {
                            attrs: {
                              type: "text",
                              name: "email",
                              id: "email",
                              label: "Email",
                              placeholder: "Masukkan email"
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          }),
                          _vm._v(" "),
                          _c("fg-input", {
                            attrs: {
                              type: "text",
                              name: "phone",
                              id: "phone",
                              label: "Telelpon",
                              placeholder: "Masukkan nomor telepon"
                            },
                            model: {
                              value: _vm.model.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "phone", $$v)
                              },
                              expression: "model.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm._l(_vm.lines, function(line, index) {
                return _c(
                  "b-row",
                  { key: index, staticClass: "border ml-0 mr-0 mb-5 mt-3" },
                  [
                    _vm.isNewCustomer || _vm.model.customer.value !== null
                      ? [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.$route.params.id === undefined
                                ? _c(
                                    "fg-input",
                                    { attrs: { label: "Produk" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group input-typeahead",
                                          class:
                                            _vm.productError !== null
                                              ? "has-error"
                                              : ""
                                        },
                                        [
                                          _c("typeahead", {
                                            ref: "userProfileUuidTypeahead",
                                            refInFor: true,
                                            attrs: {
                                              customQueryParamName: "name",
                                              disabled: true,
                                              labelFields: ["product_name"],
                                              placeholder: "Cari Product",
                                              urlSearch:
                                                _vm.apiUrl.productSearch,
                                              "arr-response": "data",
                                              model: line.product,
                                              formType: "productSearch"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.productError !== null
                                            ? _c("p", {
                                                staticClass: "error",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.productError
                                                  )
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _c(
                                    "fg-input",
                                    { attrs: { label: "Product" } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(line.product.name) +
                                            " - " +
                                            _vm._s(line.product.category) +
                                            " - " +
                                            _vm._s(line.product.color) +
                                            " - " +
                                            _vm._s(line.product.size)
                                        )
                                      ])
                                    ]
                                  )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "3 pl-3" } },
                            [
                              _vm.model.customer.category ===
                                "Sepesial Member" &&
                              Object.keys(line.product).length > 0
                                ? _c(
                                    "fg-input",
                                    { attrs: { label: "Harga Jual" } },
                                    [
                                      _c("p", { staticClass: "pt-2" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              line.product.sellingPrice > 0
                                                ? _vm.formatNumber(
                                                    line.product.smPrice *
                                                      line.quantity
                                                  )
                                                : 0
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                : _vm.model.customer.category === "Member" &&
                                  Object.keys(line.product).length > 0
                                  ? _c(
                                      "fg-input",
                                      { attrs: { label: "Harga Jual" } },
                                      [
                                        _c("p", { staticClass: "pt-2" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                line.product.sellingPrice > 0
                                                  ? _vm.formatNumber(
                                                      line.product.memberPrice *
                                                        line.quantity
                                                    )
                                                  : 0
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm.model.customer.category ===
                                      "Dropshipper" &&
                                    Object.keys(line.product).length > 0
                                    ? _c(
                                        "fg-input",
                                        { attrs: { label: "Harga Jual" } },
                                        [
                                          _c("p", { staticClass: "pt-2" }, [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  line.product.sellingPrice > 0
                                                    ? _vm.formatNumber(
                                                        line.product
                                                          .dropshipper *
                                                          line.quantity
                                                      )
                                                    : 0
                                                )
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    : _vm.model.customer.category ===
                                        "Gold Member" &&
                                      Object.keys(line.product).length > 0
                                      ? _c(
                                          "fg-input",
                                          { attrs: { label: "Harga Jual" } },
                                          [
                                            _c("p", { staticClass: "pt-2" }, [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    line.product.sellingPrice >
                                                    0
                                                      ? _vm.formatNumber(
                                                          line.product
                                                            .gold_member *
                                                            line.quantity
                                                        )
                                                      : 0
                                                  )
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : (_vm.totalQty > 2 &&
                                          _vm.totalQty <= 11 &&
                                          (_vm.lines.length > 2 &&
                                            _vm.lines.length <= 11)) ||
                                        (line.quantity > 2 &&
                                          line.quantity <= 11 &&
                                          (_vm.model.customer.category !==
                                            "Member" ||
                                            _vm.model.customer.category !==
                                              "Sepesial Member") &&
                                          Object.keys(line.product).length > 0)
                                        ? _c(
                                            "fg-input",
                                            { attrs: { label: "Harga Jual" } },
                                            [
                                              _c("p", { staticClass: "pt-2" }, [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      line.product
                                                        .sellingPrice > 0
                                                        ? _vm.formatNumber(
                                                            line.product.more3 *
                                                              line.quantity
                                                          )
                                                        : 0
                                                    )
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : (_vm.totalQty >= 11 &&
                                            _vm.lines.length > 11) ||
                                          (line.quantity > 11 &&
                                            (_vm.model.customer.category !==
                                              "Member" ||
                                              _vm.model.customer.category !==
                                                "Sepesial Member") &&
                                            Object.keys(line.product).length >
                                              0)
                                          ? _c(
                                              "fg-input",
                                              {
                                                attrs: { label: "Harga Jual" }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "pt-2" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          line.product
                                                            .sellingPrice > 0
                                                            ? _vm.formatNumber(
                                                                line.product
                                                                  .more12 *
                                                                  line.quantity
                                                              )
                                                            : 0
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm.totalQty > 2 &&
                                            _vm.totalQty <= 11 &&
                                            (_vm.model.customer.category !==
                                              "Member" ||
                                              _vm.model.customer.category !==
                                                "Sepesial Member") &&
                                            Object.keys(line.product).length > 0
                                            ? _c(
                                                "fg-input",
                                                {
                                                  attrs: { label: "Harga Jual" }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    { staticClass: "pt-2" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            line.product
                                                              .sellingPrice > 0
                                                              ? _vm.formatNumber(
                                                                  line.product
                                                                    .more3 *
                                                                    line.quantity
                                                                )
                                                              : 0
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm.totalQty >= 11 &&
                                              (_vm.model.customer.category !==
                                                "Member" ||
                                                _vm.model.customer.category !==
                                                  "Sepesial Member") &&
                                              Object.keys(line.product).length >
                                                0
                                              ? _c(
                                                  "fg-input",
                                                  {
                                                    attrs: {
                                                      label: "Harga Jual"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              line.product
                                                                .sellingPrice >
                                                              0
                                                                ? _vm.formatNumber(
                                                                    line.product
                                                                      .more12 *
                                                                      line.quantity
                                                                  )
                                                                : 0
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : Object.keys(line.product)
                                                  .length > 0
                                                ? _c(
                                                    "fg-input",
                                                    {
                                                      attrs: {
                                                        label: "Harga Jual"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "pt-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatNumber(
                                                                  line.product
                                                                    .sellingPrice *
                                                                    line.quantity
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c("fg-input", {
                                attrs: {
                                  label: "Kuantitas",
                                  type: "number",
                                  disabled: _vm.$route.params.id !== undefined
                                },
                                model: {
                                  value: line.quantity,
                                  callback: function($$v) {
                                    _vm.$set(line, "quantity", $$v)
                                  },
                                  expression: "line.quantity"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "1 mt-4-5 text-center" } },
                            [
                              index >= 1 && _vm.$route.params.id === undefined
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-danger",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.removeLine(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-times" })]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "1 mt-4-5 ml-2 text-center" } },
                            [
                              index + 1 === _vm.lines.length
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "button",
                                        variant: "primary"
                                      },
                                      on: { click: _vm.addLine }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "plus" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("fg-input", {
                        attrs: { label: "Diskon", type: "number" },
                        model: {
                          value: _vm.model.diskon,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "diskon", $$v)
                          },
                          expression: "model.diskon"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("fg-input", {
                        attrs: { label: "PPN (%)", type: "number" },
                        model: {
                          value: _vm.model.ppn,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "ppn", $$v)
                          },
                          expression: "model.ppn"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "fg-input",
                        { attrs: { label: "Mau disablon?" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "isSablon",
                                  options: _vm.optionsSablon,
                                  name: "radio-sablon"
                                },
                                model: {
                                  value: _vm.model.isSablon,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "isSablon", $$v)
                                  },
                                  expression: "model.isSablon"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.model.isSablon === 1
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("fg-input", { attrs: { label: "Sablon" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group input-typeahead",
                                class:
                                  _vm.sablonError !== null ? "has-error" : ""
                              },
                              [
                                _c("typeahead", {
                                  ref: "userProfileUuidTypeahead",
                                  attrs: {
                                    customQueryParamName: "title",
                                    labelFields: ["title"],
                                    placeholder: "Cari Sablon",
                                    urlSearch: _vm.apiUrl.sablon,
                                    "arr-response": "data",
                                    model: _vm.model.sablon
                                  }
                                }),
                                _vm._v(" "),
                                _vm.sablonError !== null
                                  ? _c("p", {
                                      staticClass: "error",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.sablonError)
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "fg-input",
                            { attrs: { label: "Harga Jual Sablon" } },
                            [
                              _c("p", { staticClass: "pt-2" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.model.sablon.sellingPrice *
                                          _vm.model.sablonQuantity
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("fg-input", {
                            attrs: {
                              label: "Kuantitas",
                              type: "number",
                              min: "1"
                            },
                            model: {
                              value: _vm.model.sablonQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sablonQuantity", $$v)
                              },
                              expression: "model.sablonQuantity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.model.customer.category !== null &&
              _vm.model.customer.category === "Pelanggan" &&
              _vm.model.customer.count_point >= 5000 &&
              _vm.totalSummary >= 50000
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "fg-input",
                              { attrs: { label: "Gunakan Point?" } },
                              [
                                _c(
                                  "b-form-group",
                                  [
                                    _c("b-form-radio-group", {
                                      attrs: {
                                        id: "isUsePoint",
                                        options: _vm.optionsPoint,
                                        name: "radio-sablon"
                                      },
                                      model: {
                                        value: _vm.model.is_use_point,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "is_use_point",
                                            $$v
                                          )
                                        },
                                        expression: "model.is_use_point"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.model.is_use_point === true
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "fg-input",
                                  { attrs: { label: "Total point saat ini" } },
                                  [
                                    _c("p", { staticClass: "pt-2" }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPoint(
                                              _vm.model.customer.count_point
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("fg-input", {
                                  attrs: {
                                    label: "Total Penggunaan Point",
                                    type: "number",
                                    min: "1",
                                    max: _vm.model.customer.count_point
                                  },
                                  model: {
                                    value: _vm.model.how_use,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "how_use", $$v)
                                    },
                                    expression: "model.how_use"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "fg-input",
                        { attrs: { label: "Cara Pembayaran" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "method-payement",
                                  options: _vm.optionsPaymentType,
                                  name: "radio-method-payement"
                                },
                                model: {
                                  value: _vm.model.paymentType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "paymentType", $$v)
                                  },
                                  expression: "model.paymentType"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "fg-input",
                        { attrs: { label: "Shipping Payment" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "number",
                                  id: "shipping-payement",
                                  name: "shipping-payement"
                                },
                                model: {
                                  value: _vm.model.shipping,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "shipping", $$v)
                                  },
                                  expression: "model.shipping"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.model.paymentType === 2
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("fg-input", {
                            attrs: { label: "Jumlah DP", type: "number" },
                            model: {
                              value: _vm.model.downPayment,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "downPayment", $$v)
                              },
                              expression: "model.downPayment"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "fg-input",
                            { attrs: { label: "sisa pembayaran" } },
                            [
                              _c("p", { staticClass: "pt-2" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.totalSummary - _vm.model.downPayment
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [_c("cancel-button")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          on: {
                            click: function($event) {
                              _vm.doSubmit(4)
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sticky-note" }
                          }),
                          _vm._v(" Simpan sebagai draft")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("save-data-button", {
                        attrs: {
                          disabled: _vm.saveButtonData.isLoading,
                          "is-create": _vm.$route.params.id === undefined,
                          state:
                            _vm.saveButtonData.isLoading &&
                            _vm.saveButtonData.state === 1
                              ? 2
                              : _vm.saveButtonData.state,
                          "is-loading": _vm.saveButtonData.isLoading
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "bubble-info" }, [
      _vm.model.customer.category !== null &&
      _vm.model.customer.category === "Pelanggan"
        ? _c("div", { staticClass: "btn btn-warning" }, [
            _c("strong", [
              _vm._v(
                "Total Point: " +
                  _vm._s(_vm.formatPoint(_vm.model.customer.count_point))
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "btn btn-info" }, [
        _c("strong", [
          _vm._v("Total : " + _vm._s(_vm.formatNumber(_vm.totalSummary)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eb82bd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb82bd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Orders/Form.vue
// module id = bDUm
// module chunks = 4